// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__RsU34","Alert":"Layout_Alert__iW+6+"};